import {BrowserModule, Title, TransferState} from '@angular/platform-browser';

import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injectable, LOCALE_ID, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {AngularWebStorageModule} from 'angular-web-storage';
import {CarouselModule} from 'ngx-owl-carousel-o';
// Import your library
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';
// RECOMMENDED
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
// Locale
import localeRu from '@angular/common/locales/ru';
import {DatePipe, DecimalPipe, registerLocaleData} from '@angular/common';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import {AppComponent} from './app.component';
import {MessagesShowComponent} from './components/messages-show/messages-show.component';
import {MessagesListComponent} from './components/messages-list/messages-list.component';
import {ChatShowComponent} from './components/chat-show/chat-show.component';
import {ChatListComponent} from './components/chat-list/chat-list.component';

import {DynamicScriptLoaderService} from './services/dynamic-script-loader.service';
import {VkService} from './pages/page-vk/vk.service';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PageSkypeComponent} from './pages/page-skype/page-skype.component';
import {PageStartComponent} from './pages/page-start/page-start.component';
import {PageTelegramComponent} from './pages/page-telegram/page-telegram.component';
import {SignTelegramComponent} from './pages/page-telegram/sign-telegram/sign-telegram.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SignSkypeComponent} from './pages/page-skype/sign-skype/sign-skype.component';
import {DeferLoadDirective} from './defer-load.directive';

import {ContactsListComponent} from './components/contacts-list/contacts-list.component';
import {EventSubscribeService} from './services/event-subscribe.service';
import {PickerModule} from '@ctrl/ngx-emoji-mart';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {ReplaceEmojisPipe} from './pipes/emoji.pipe';
import {HrefPipe} from './pipes/href.pipe';
import {VoiceComponent} from './components/chat-show/voice/voice.component';
import {
  MessageAttachmentsComponent
} from './components/chat-show/message/message-attachments/message-attachments.component';
import {TextareaAutosizeModule} from 'ngx-textarea-autosize';
import {MessagePlayerComponent} from './components/chat-show/message/message-player/message-player.component';
import {FeatherModule} from 'angular-feather';
import {TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule} from 'ngx-timeago';
import {TelegramService} from './pages/page-telegram/telegram.service';
import {TestComponent} from './components/test/test.component';
import {AudioService} from './services/audio.service';
import {PushNotificationsModule, PushNotificationsService} from 'ng-push-ivy';
import {VoicePlayerComponent} from './components/chat-show/message/voice-player/voice-player.component';
import {MessageComponent} from './components/chat-show/message/message.component';
import {PageVkComponent} from './pages/page-vk/page-vk.component';
import {DeferVizibleDirective} from './defer-vizible.directive';
import {MessagesLastDateComponent} from './components/chat-show/messages-last-date/messages-last-date.component';
import {AvatarComponent} from './components/avatar/avatar.component';
import {ChatDetailComponent} from './components/chat-show/chat-detail/chat-detail.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MessageServiceComponent} from './components/chat-show/message-service/message-service.component';

// Import Bugsnag and the Angular integration
import Bugsnag from '@bugsnag/js';
import {BugsnagErrorHandler} from '@bugsnag/plugin-angular';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {VideoPlayerComponent} from './components/chat-show/message/video-player/video-player.component';
import {
  ModalChatDetailComponent
} from './components/chat-show/chat-detail/modal-chat-detail/modal-chat-detail.component';
import {ChatSearchComponent} from './components/chat-list/chat-search/chat-search.component';
import {ChatNewComponent} from './components/chat-new/chat-new.component';
import {AlertModule} from 'ngx-bootstrap/alert';
import {ProfileComponent} from './components/profile/profile.component';
import {ErrorShowComponent} from './components/error-show/error-show.component';
import {ContextMenuModule, ContextMenuService} from 'ngx-contextmenu';
import {ModalMapComponent} from './components/chat-show/message/modal-map/modal-map.component';
import {TgsPlayerComponent} from './components/chat-show/message/tgs-player/tgs-player.component';
import {MessagesScrollComponent} from './components/chat-show/messages-scroll/messages-scroll.component';
import {ObserveVisibilityDirective} from './observe-visibility.directive';
import {ChatMediaRightComponent} from './components/chat-show/chat-media-right/chat-media-right.component';
import {ModalVideoCallsComponent} from './components/modal-video-calls/modal-video-calls.component';
/// Zorro
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzSpaceModule} from 'ng-zorro-antd/space';
import {NzSliderModule} from 'ng-zorro-antd/slider';
import {NzAffixModule} from 'ng-zorro-antd/affix';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {ClickOutsideDirective} from './directives/click.outside.directive';
import {WebsocketModule} from './services/websocket';
import {environment} from '../environments/environment';
import {PageWhatsappComponent} from './pages/page-whatsapp/page-whatsapp.component';

// Lottie
import {LottieModule, LottieTransferState} from 'ngx-lottie';
import player from 'lottie-web/build/player/lottie_light';
import {NavbarComponent} from './template/navbar/navbar.component';
import {OnlineSliderComponent} from './components/chat-list/online-slider/online-slider.component';
import {
  ModalForwardMessageComponent
} from './components/chat-show/modal-forward-message/modal-forward-message.component';
import {PageStartContentComponent} from './pages/page-start/page-start-content/page-start-content.component';
import {
  ModalNotifySettingsComponent
} from './components/chat-list/modal-notify-settings/modal-notify-settings.component';
import {VkLongPullService} from './pages/page-vk/vk.longpull.service';
import {DeclinationPipe} from './pipes/declination.pipe';
import {TextUserOnlineComponent} from './components/chat-show/text-user-online/text-user-online.component';
import {GalleryService} from './services/gallery.service';
import {MessageWallComponent} from './components/chat-show/message-wall/message-wall.component';
import {IconMimeComponent} from './components/svg-icons/icon-mime/icon-mime.component';
import {SignVkComponent} from './pages/page-vk/sign-vk/sign-vk.component';
import {
  ModalAddChatMemberComponent
} from './components/chat-show/modal-add-chat-member/modal-add-chat-member.component';
import {SignWhatsappComponent} from './pages/page-whatsapp/sign-whatsapp/sign-whatsapp.component';
import {WhatsappService} from './pages/page-whatsapp/whatsapp.service';
import {AllService} from './services/all.service';
import {BatteryIndicatorComponent} from './components/chat-list/battery-indicator/battery-indicator.component';
import {AvatarUserComponent} from './components/avatar/avatar-user/avatar-user.component';
import {NotificationService} from './services/notification.service';
import {ModalCopyTextComponent} from './components/chat-show/message/modal-copy-text/modal-copy-text.component';
import {MessageCompactComponent} from './components/chat-show/message/message-compact/message-compact.component';
import {
  MessageAttachmentsCompactComponent
} from './components/chat-show/message/message-attachments-compact/message-attachments-compact.component';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {ServiceWorkerModule} from '@angular/service-worker';
import {
  MessagesProfileComponent
} from './components/chat-show/messages-scroll/messages-profile/messages-profile.component';

import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {ContextMenuFixService} from './services/contextMenu.service';
import {ModalAddAccountComponent} from './pages/page-start/modal-add-account/modal-add-account.component';
import {SettingsService} from './services/settings.service';
import {FileSaverModule} from 'ngx-filesaver';
import {GsPlayerModule} from 'gs-player';
import {ThemeService} from './services/theme.service';
import {MusicPlayerComponent} from './components/music-player/music-player.component';
import {MessagePinnedComponent} from './components/chat-show/message/message-pinned/message-pinned.component';
import {
  ModalMessagePinnedComponent
} from './components/chat-show/message/message-pinned/modal-message-pinned/modal-message-pinned.component';
import {InterfaceService} from './services/interface.service';
import {AllMessengersService} from './pages/page-start/all-messengers.service';
import {PageFellowdeskComponent} from './pages/page-fellowdesk/page-fellowdesk.component';
import {FellowdeskService} from './pages/page-fellowdesk/fellowdesk.service';
import {SignFellowdeskComponent} from './pages/page-fellowdesk/sign-fellowdesk/sign-fellowdesk.component';
import {PageCalcComponent} from './pages/page-calc/page-calc.component';
import {NgxMasonryModule} from 'ngx-masonry';
import {WebrtcService} from './services/webrtc.service';
import {CallService} from './services/call.service';
import {ModalService} from './services/modal.service';
import {
  ModalVideoCallIncomingComponent
} from './components/modal-video-calls/modal-video-call-incoming/modal-video-call-incoming.component';
import {NgxModalDraggableDirective} from './directives/draggable.directive';
import {ModalHeaderComponent} from './template/modal-header/modal-header.component';
import {StreamUserItemComponent} from './components/modal-video-calls/stream-user-item/stream-user-item.component';
import {SenderChatItemComponent} from './components/chat-list/sender-chat-item/sender-chat-item.component';
import {SenderService} from './services/sender.service';
import {MessageSenderComponent} from './components/chat-show/message-sender/message-sender.component';
import {AddFormSenderComponent} from './components/chat-show/add-form-sender/add-form-sender.component';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzProgressModule} from 'ng-zorro-antd/progress';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {FixTypePipe} from './pipes/fixtype.pipe';
import {NotifierWrapService} from './services/notifier-wrap.service';
import {ModalSerrosContactsComponent} from './components/chat-show/add-form-sender/modal-serros-contacts/modal-serros-contacts.component';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import {NzResultModule} from 'ng-zorro-antd/result';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {AddFormChatStepComponent} from './components/chat-show/add-form-sender/add-form-chat-step/add-form-chat-step.component';
import {AppService} from './services/app.service';
import {ModalAddBalanceComponent} from './components/chat-show/modal-add-balance/modal-add-balance.component';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NgxEditorModule} from 'ngx-editor';
import { MessageEditorComponent } from './components/chat-show/message-editor/message-editor.component';
import { DemoMessageSenderComponent } from './components/chat-show/message-sender/demo-message-sender/demo-message-sender.component';
import { SenderShepherdComponent } from './components/sender-shepherd/sender-shepherd.component';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import { ModalSenderRegisterComponent } from './pages/page-telegram/sign-telegram/modal-sender-register/modal-sender-register.component';
import {ChatGptService} from './services/chat-gpt.service';
import { MessageSenderPartnerComponent } from './components/chat-show/message-sender-partner/message-sender-partner.component';
import { AlertErrorComponent } from './components/error-show/alert-error/alert-error.component';
import { SignTelegramTdataComponent } from './pages/page-telegram/sign-telegram/sign-telegram-tdata/sign-telegram-tdata.component';
import { ChatListFilterComponent } from './components/chat-list/chat-list-filter/chat-list-filter.component';
import { ChatItemComponent } from './components/chat-list/chat-item/chat-item.component';
import {AuthModule} from './modules/auth/auth.module';
import { TextVariationsShepherdComponent } from './components/sender-shepherd/text-variations-shepherd/text-variations-shepherd.component';
import {ToursService} from './services/tours.service';
import { ProfileUsernameComponent } from './components/profile/profile-username/profile-username.component';
import { FaqParseComponent } from './modules/sender/modals/faq/faq-parse/faq-parse.component';
import { ProfileAvatarComponent } from './components/profile/profile-avatar/profile-avatar.component';
import { SendLimitComponent } from './modules/sender/modals/faq/send-limit/send-limit.component';
import {ServiceNumberPipe} from './pipes/service.number.pipe';
import { BanAccountsComponent } from './modules/sender/modals/faq/ban-accounts/ban-accounts.component';
import { AddFormPostInputComponent } from './components/chat-show/add-form-sender/add-form-post-input/add-form-post-input.component';
import { FaqPostComponent } from './modules/sender/modals/faq/faq-post/faq-post.component';
import { SenderForgotComponent } from './pages/page-telegram/sign-telegram/modal-sender-register/sender-forgot/sender-forgot.component';
import { SenderArendComponent } from './pages/page-telegram/sign-telegram/modal-sender-register/sender-arend/sender-arend.component';
import { SenderAuthComponent } from './pages/page-telegram/sign-telegram/modal-sender-register/sender-auth/sender-auth.component';
import { SenderRegisterComponent } from './pages/page-telegram/sign-telegram/modal-sender-register/sender-register/sender-register.component';
import { PageLeadsComponent } from './pages/page-leads/page-leads.component';
import { KanbanModule } from '@syncfusion/ej2-angular-kanban';
import { CustomReuseStrategy } from './route.cache';
import { NzTableModule } from 'ng-zorro-antd/table';
import { LeadsScanTasksTableComponent } from './pages/page-leads/leads-scan-tasks-table/leads-scan-tasks-table.component';
import { LeadsModule } from './modules/leads/leads.module';
import { LeadsScanTasksEditComponent } from './pages/page-leads/leads-scan-tasks-edit/leads-scan-tasks-edit.component';
import { LeadsScanTasksEditMultiFieldComponent } from './pages/page-leads/leads-scan-tasks-edit-multi-field/leads-scan-tasks-edit-multi-field.component';
import { LeadsScanTasksEditModalComponent } from './pages/page-leads/leads-scan-tasks-edit-modal/leads-scan-tasks-edit-modal.component';
import { LeadsScanTasksKanbanComponent } from './pages/page-leads/leads-scan-tasks-kanban/leads-scan-tasks-kanban.component';

registerLocaleData(localeRu);

import { NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import { AuthInnerComponent } from './template/auth-inner/auth-inner.component';
import { ChatShowInnerComponent } from './components/chat-show-inner/chat-show-inner.component';
import { LeadsScanTasksSubscribeComponent } from './pages/page-leads/leads-scan-tasks-subscribe/leads-scan-tasks-subscribe.component';
import { PageScanTasksComponent } from './pages/page-scan-tasks/page-scan-tasks.component';
import { LeadsNavbarComponent } from './template/leads-navbar/leads-navbar.component';
import { LeadsTopBarComponent } from './template/leads-top-bar/leads-top-bar.component';
import { LeadsScanTasksListComponent } from './pages/page-leads/leads-scan-tasks-list/leads-scan-tasks-list.component';
import { ModalLeadsTariffComponent } from './template/modals/modal-leads-tariff/modal-leads-tariff.component';
import { bold, icons, italic, strike, underline } from './main.icons';
import { ModalFirstFaqVideoComponent } from './template/modals/modal-first-faq-video/modal-first-faq-video.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { LeadsScanTasksAutomessageComponent } from './pages/page-leads/leads-scan-tasks-edit/leads-scan-tasks-automessage/leads-scan-tasks-automessage.component';
import { MessageEditorSingleComponent } from './components/chat-show-inner/message-editor-single/message-editor-single.component';
import { LeadsScanTasksKanbanFilterComponent } from './pages/page-leads/leads-scan-tasks-kanban/leads-scan-tasks-kanban-filter/leads-scan-tasks-kanban-filter.component';
import { ModalResultContactsComponent } from './components/chat-show/add-form-sender/modal-result-contacts/modal-result-contacts.component';
import { LeadTaskShepherdComponent } from './components/sender-shepherd/lead-task-shepherd/lead-task-shepherd.component';
import {JazziconModule} from "ngx-jazzicon";


// ... other imports omitted for brevity

// configure Bugsnag asap
Bugsnag.start({apiKey: 'e8b350661c8775909ccb03ec3875ec0e'});

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

@Injectable()
export class MyIntl extends TimeagoIntl {
  // do extra stuff here...
}

export function playerFactory() {
  return player;
}

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  dictDefaultMessage: 'Перетащите сюда файлы для загрузки',
  dictFallbackMessage: 'Ваш браузер не поддерживает загрузку файлов методом перетаскивания.',
  dictFallbackText: 'Воспользуйтесь формой ниже, чтобы загрузить файлы, как в былые времена.',
  dictFileTooBig: `Максимальный размер: {{maxFilesize}}Мб. Рекомендуем воспользоваться https//disk.yandex.ru`,
  dictInvalidFileType: 'Вы не можете загружать файлы этого типа.',
  dictResponseError: 'Сервер ответил кодом {{statusCode}}.',
  dictCancelUpload: 'Отменить загрузку',
  dictCancelUploadConfirmation: 'Вы уверены, что хотите отменить эту загрузку?',
  dictRemoveFile: 'Удалить файл',
  dictMaxFilesExceeded: 'Вы не можете больше загружать файлы.',
  maxFilesize: 200,
  timeout: 3600000,
  url: 'https://test.com'
};

@NgModule({
  declarations: [
    AppComponent,
    MessagesShowComponent,
    MessagesListComponent,
    ChatShowComponent,
    ChatListComponent,
    PageSkypeComponent,
    PageStartComponent,
    PageTelegramComponent,
    SignTelegramComponent,
    SignSkypeComponent,
    NgxModalDraggableDirective,
    DeferLoadDirective,
    ClickOutsideDirective,
    DeferVizibleDirective,
    ObserveVisibilityDirective,
    ContactsListComponent,
    ReplaceEmojisPipe,
    HrefPipe,
    FixTypePipe,
    ServiceNumberPipe,
    VoiceComponent,
    MessageAttachmentsComponent,
    MessagePlayerComponent,
    TestComponent,
    VoicePlayerComponent,
    MessageComponent,
    PageVkComponent,
    MessagesLastDateComponent,
    AvatarComponent,
    StreamUserItemComponent,
    ChatDetailComponent,
    MessageServiceComponent,
    MessageSenderComponent,
    VideoPlayerComponent,
    ModalChatDetailComponent,
    ModalSerrosContactsComponent,
    ModalResultContactsComponent,
    ChatSearchComponent,
    ChatNewComponent,
    ProfileComponent,
    ErrorShowComponent,
    ModalMapComponent,
    TgsPlayerComponent,
    MessagesScrollComponent,
    ChatMediaRightComponent,
    ModalVideoCallsComponent,
    ModalSenderRegisterComponent,
    ModalVideoCallIncomingComponent,
    PageWhatsappComponent,
    NavbarComponent,
    OnlineSliderComponent,
    ModalForwardMessageComponent,
    PageStartContentComponent,
    ModalNotifySettingsComponent,
    DeclinationPipe,
    TextUserOnlineComponent,
    MessageWallComponent,
    IconMimeComponent,
    SignVkComponent,
    ModalAddChatMemberComponent,
    SignWhatsappComponent,
    BatteryIndicatorComponent,
    AvatarUserComponent,
    ModalCopyTextComponent,
    MessageCompactComponent,
    MessageAttachmentsCompactComponent,
    MessagesProfileComponent,
    ModalAddAccountComponent,
    MusicPlayerComponent,
    MessagePinnedComponent,
    ModalMessagePinnedComponent,
    PageFellowdeskComponent,
    SignFellowdeskComponent,
    PageCalcComponent,
    ModalVideoCallIncomingComponent,
    ModalHeaderComponent,
    ModalHeaderComponent,
    SenderChatItemComponent,
    AddFormSenderComponent,
    AddFormChatStepComponent,
    ModalAddBalanceComponent,
    ModalLeadsTariffComponent,
    MessageEditorComponent,
    DemoMessageSenderComponent,
    SenderShepherdComponent,
    ModalSenderRegisterComponent,
    MessageSenderPartnerComponent,
    AlertErrorComponent,
    SignTelegramTdataComponent,
    ChatListFilterComponent,
    ChatItemComponent,
    TextVariationsShepherdComponent,
    ProfileUsernameComponent,
    FaqParseComponent,
    ProfileAvatarComponent,
    SendLimitComponent,
    BanAccountsComponent,
    AddFormPostInputComponent,
    FaqPostComponent,
    SenderForgotComponent,
    SenderArendComponent,
    SenderAuthComponent,
    SenderRegisterComponent,
    PageLeadsComponent,
    LeadsScanTasksTableComponent,
    LeadsScanTasksEditComponent,
    LeadsScanTasksEditMultiFieldComponent,
    LeadsScanTasksEditModalComponent,
    LeadsScanTasksKanbanComponent,
    AuthInnerComponent,
    ChatShowInnerComponent,
    LeadsScanTasksSubscribeComponent,
    PageScanTasksComponent,
    LeadsNavbarComponent,
    LeadsTopBarComponent,
    LeadsScanTasksListComponent,
    ModalFirstFaqVideoComponent,
    LeadsScanTasksAutomessageComponent,
    MessageEditorSingleComponent,
    LeadsScanTasksKanbanFilterComponent,
    ModalResultContactsComponent,
    LeadTaskShepherdComponent
  ],
  imports: [
    AuthModule,
    LeadsModule,
    KanbanModule,
    NgxEditorModule.forRoot({
      locals: {
        bold: 'Жирный',
        italic: 'Косой',
        code: 'Разметить код',
        underline: 'Подчеркнутый',
        heading: 'Заголовки',
        header: 'Заголовок',
        strike: 'Зачеркнутый',
        insertLink: 'Вставить ссылку',
        removeLink: 'Удалить ссылку',
        url: 'URL страницы',
        text: 'Текст',
        openInNewTab: 'Открывать в новой вкладке',
        insert: 'Вставить',
        altText: 'Весь текст',
        title: 'Заголовок',
        remove: 'Удалить',
      },
      icons: {
        bold,
        italic,
        underline,
        strike
      }
    }),
    NgxMasonryModule,
    GsPlayerModule,
    DropzoneModule,
    IvyCarouselModule,
    SnotifyModule,
    NzToolTipModule,
    // NgxElectronModule,
    LottieModule.forRoot({
      player: playerFactory // useCache: true
    }),
    WebsocketModule.config({
      url: environment.wss
    }),
    ContextMenuModule.forRoot({
      useBootstrap4: true
    }),
    TimeagoModule.forRoot({
      intl: {provide: TimeagoIntl, useClass: MyIntl},
      formatter: {provide: TimeagoFormatter, useClass: TimeagoCustomFormatter}
    }),
    ModalModule.forRoot(),
    CarouselModule,
    // ScrollToModule.forRoot(),
    // PerfectScrollbarModule,
    // AngularDropdownModule,
    TooltipModule.forRoot(),
    PushNotificationsModule,
    FeatherModule.pick(icons),
    PickerModule,
    EmojiModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularWebStorageModule,
    HttpClientModule,
    BrowserModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TextareaAutosizeModule,
    BsDropdownModule,
    TabsModule,
    AlertModule,
    // NzFormModule,
    // NzInputModule,
    NzModalModule,
    NzDropDownModule,
    NzButtonModule,
    NzAffixModule,
    NzSliderModule,
    NzSkeletonModule,
    NzSpaceModule,
    NzCheckboxModule,
    NzUploadModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //  enabled: true,
    // Register the ServiceWorker as soon as the app is stable
    // or after 30 seconds (whichever comes first).
    // registrationStrategy: 'registerWhenStable:30000'
    // })
    FileSaverModule,
    NzFormModule,
    NzProgressModule,
    NzSpinModule,
    NzStepsModule,
    NzResultModule,
    NzDatePickerModule,
    NzInputModule,
    NzInputNumberModule,
    NzRadioModule,
    NzSelectModule,
    NzTabsModule,
    NzAlertModule,
    NzTableModule,
    NzCollapseModule,
    /*NgxMetrikaModule.forRoot({
      id: environment.yaCounterId,
      defer: true,
      webvisor: true,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    }),*/
    JazziconModule.forRoot(),
  ],
  exports: [TooltipModule, TimeagoModule, FeatherModule],
  providers: [
    {
      provide: NZ_I18N,
      useValue: ru_RU,
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    AppService,
    ToursService,
    InterfaceService,
    SettingsService,
    NotifierWrapService,
    ModalService,
    SenderService,
    AllMessengersService,
    {
      provide: ContextMenuService,
      useExisting: ContextMenuFixService
    },
    {provide: 'ContextMenuServiceLead', useClass: ContextMenuService, useExisting: ContextMenuFixService},
    Title,
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    {provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService,
    // { provide: GlobalData, useValue: new GlobalData() },
    // { provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    // #docregion interceptor-providers
    // { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    DeclinationPipe,
    ModalForwardMessageComponent,
    ModalCopyTextComponent,
    ModalAddAccountComponent,
    ModalMessagePinnedComponent,
    ModalSerrosContactsComponent,
    ModalResultContactsComponent,
    ChatDetailComponent,
    TimeagoIntl,
    {provide: ErrorHandler, useFactory: errorHandlerFactory},
    PushNotificationsService,
    VkService,
    WhatsappService,
    FellowdeskService,
    GalleryService,
    NotificationService,
    VkLongPullService,
    HrefPipe,
    FixTypePipe,
    ServiceNumberPipe,
    BsModalRef,
    TelegramService,
    {provide: 'TelegramService2', useClass: TelegramService},
    {provide: 'TelegramService3', useClass: TelegramService},
    {provide: 'TelegramService4', useClass: TelegramService},
    {provide: 'TelegramService5', useClass: TelegramService},
    {provide: 'TelegramService6', useClass: TelegramService},
    {provide: 'TelegramService7', useClass: TelegramService},
    {provide: 'TelegramService8', useClass: TelegramService},
    {provide: 'TelegramService9', useClass: TelegramService},
    {provide: 'TelegramService10', useClass: TelegramService},
    {provide: 'TelegramService11', useClass: TelegramService},
    {provide: 'TelegramService12', useClass: TelegramService},
    {provide: 'TelegramService13', useClass: TelegramService},
    {provide: 'TelegramService14', useClass: TelegramService},
    {provide: 'TelegramService15', useClass: TelegramService},
    {provide: 'TelegramService16', useClass: TelegramService},
    {provide: 'TelegramService17', useClass: TelegramService},
    {provide: 'TelegramService18', useClass: TelegramService},
    {provide: 'TelegramService19', useClass: TelegramService},
    {provide: 'TelegramService20', useClass: TelegramService},
    {provide: 'TelegramService21', useClass: TelegramService},
    {provide: 'TelegramService22', useClass: TelegramService},
    {provide: 'TelegramService23', useClass: TelegramService},
    {provide: 'TelegramService24', useClass: TelegramService},
    {provide: 'TelegramService25', useClass: TelegramService},
    {provide: 'TelegramService26', useClass: TelegramService},
    {provide: 'TelegramService27', useClass: TelegramService},
    {provide: 'TelegramService28', useClass: TelegramService},
    {provide: 'TelegramService29', useClass: TelegramService},
    {provide: 'TelegramService30', useClass: TelegramService},
    {provide: 'TelegramService31', useClass: TelegramService},
    {provide: 'TelegramService32', useClass: TelegramService},
    {provide: 'TelegramService33', useClass: TelegramService},
    {provide: 'TelegramService34', useClass: TelegramService},
    {provide: 'TelegramService35', useClass: TelegramService},
    {provide: 'TelegramService36', useClass: TelegramService},
    {provide: 'TelegramService37', useClass: TelegramService},
    {provide: 'TelegramService38', useClass: TelegramService},
    {provide: 'TelegramService39', useClass: TelegramService},
    {provide: 'TelegramService40', useClass: TelegramService},
    {provide: 'TelegramService41', useClass: TelegramService},
    {provide: 'TelegramService42', useClass: TelegramService},
    {provide: 'TelegramService43', useClass: TelegramService},
    {provide: 'TelegramService44', useClass: TelegramService},
    {provide: 'TelegramService45', useClass: TelegramService},
    {provide: 'TelegramService46', useClass: TelegramService},
    {provide: 'TelegramService47', useClass: TelegramService},
    {provide: 'TelegramService48', useClass: TelegramService},
    {provide: 'TelegramService49', useClass: TelegramService},
    {provide: 'TelegramService50', useClass: TelegramService},
    {provide: 'TelegramService51', useClass: TelegramService},
    {provide: 'TelegramService52', useClass: TelegramService},
    {provide: 'TelegramService53', useClass: TelegramService},
    {provide: 'TelegramService54', useClass: TelegramService},
    {provide: 'TelegramService55', useClass: TelegramService},
    {provide: 'TelegramService56', useClass: TelegramService},
    {provide: 'TelegramService57', useClass: TelegramService},
    {provide: 'TelegramService58', useClass: TelegramService},
    {provide: 'TelegramService59', useClass: TelegramService},
    {provide: 'TelegramService60', useClass: TelegramService},
    DecimalPipe,
    DynamicScriptLoaderService,
    EventSubscribeService,
    ReplaceEmojisPipe,
    TransferState,
    AudioService,
    DatePipe,
    LottieTransferState,
    ChatGptService,
    ThemeService,
    WebrtcService,
    CallService,
    AllService,
    {provide: LOCALE_ID, useValue: 'ru'}
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
